import {post} from '@/utils/request';
import{erpserver} from '@/utils/baseUrl';

//查询列表
export async function getMqList(params) {
    return post(erpserver+'/exchandle/getMqList', params, true)
}
export async function getMqDetail(params) {
    return post(erpserver+'/exchandle/getMqDetail', params, true)
}
export async function resendMq(params) {
    return post(erpserver+'/exchandle/resendMq', params, true)
}
